<template>
    <!--添加档案弹窗-->
    <td-dialog width="1360px" :title="$t('workFlowProcessAudit.ADD_AUDIT')" :before-close="dialogClose" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-container class="addFileDialog">
            <el-aside class="aside">
                <div>
                    <el-form ref="asideForm" :model="asideForm" :rules="rules" labelWidth="90px">
                        <el-form-item v-for="(item, index) in expandResources" :key="index" :label="item.sRemark" :prop="item.sName">
                            <td-select v-model="item.value" :options="item.labelList" keys="sId" text="sRemark"></td-select>
                        </el-form-item>
                    </el-form>
                </div>
            </el-aside>
            <el-main>
                <el-form ref="form" :inline="true" :model="searchForm">
                    <el-form-item :label="$t('pgCommon.USERNAME')">
                        <td-input v-model="searchForm.sName"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.ROLE')">
                        <td-input v-model="searchForm.sRoleNames"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('assignAuditPermission.ORG')">
                        <td-tree-select
                            class="orgStructSelect"
                            ref="tdOrgTree"
                            nodeKey="id"
                            :defaultProps="orgTree.defaultProps"
                            :imgloading="true"
                            :multiple="true"
                            :interfaceName="orgTree.interfaceName"
                            :calInternal="true"
                            :lazyloading="true"
                            v-model="searchForm.sOrgIds"
                            :width="300"
                            :showBox="true"
                            :expandOnClick="true"
                        ></td-tree-select>
                    </el-form-item>
                    <el-form-item>
                        <td-button style="margin-left: 10px" type="primary" @click="queryUserInfo">{{ $t('pgCommon.QUERY') }}</td-button>
                    </el-form-item>
                </el-form>
                <td-table
                    ref="table"
                    height="420px"
                    :hasMutiSelect="true"
                    :columns="table.columns"
                    :dataSource="table.data"
                    :pageSize="table.pageSize"
                    :currentPage="table.currentPage"
                    :total="table.totals"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentPageChange"
                ></td-table>
            </el-main>
        </el-container>
        <div slot="footer">
            <td-button type="primary" :loading="submitLoading" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="dialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>

<script>
import Api from '@/modules/workFlowFileConfiguration/assets/api';
export default {
    name: 'addFileDialog',
    props: ['dialogVisible', 'data'],
    data() {
        return {
            submitLoading: false,
            orgTree: {
                defaultProps: {
                    parentId: 'parentId',
                    children: 'children',
                    id: 'id',
                    label: 'caption',
                    imgName: 'sIcon'
                },
                value: '',
                interfaceName: { query: '/OrgStructureController/findOrgStructureTree', search: '/OrgStructureController/findOrgStructureTree' }
            },
            asideForm: {}, //左侧表单
            rules: {}, //表单校验规则
            //正上方表单,用于查询table表信息
            searchForm: {
                sName: '', //用户名
                sRoleNames: '', //角色名
                sOrgIds: [] //组织id组
            },
            table: {
                //表头属性
                columns: [
                    {
                        prop: 'sName',
                        label: this.$t('pgCommon.USERNAME'),
                        align: 'left',
                        showOverflowTooltip: 'true'
                    },
                    {
                        prop: 'sRoleNames',
                        label: this.$t('pgCommon.USERROLE'),
                        align: 'center'
                    },
                    {
                        prop: 'sOrgNames',
                        label: this.$t('assignAuditPermission.ORG'),
                        align: 'left',
                        showOverflowTooltip: 'true'
                    }
                ],
                data: [], //table表数据
                pageSize: 10, //table表每页信息条数
                currentPage: 1, //table表当前页
                totals: '' //table表数据总条数
            },
            expandResources: [] //扩展资源
        };
    },
    created() {
        this.initExpandResource();
        this.queryUserInfo();
        this.initFormRules();
    },
    methods: {
        //初始化扩展资源信息
        initExpandResource() {
            this.expandResources = this.data.auditRelateInfo;
        },
        //初始化表单校验规则
        initFormRules() {
            let validatePass = [];
            this.expandResources.forEach((item, index) => {
                validatePass[index] = (rule, value, callback) => {
                    if (this.$util.isEmpty(item.value)) {
                        callback(new Error(this.$t('pgCommon.PLEASE_INPUT')));
                    } else {
                        callback();
                    }
                };
                this.rules[item.sName] = [{ required: true, validator: validatePass[index], trigger: 'blur' }];
            });
        },
        //查询表信息
        queryUserInfo() {
            let params = { pageSize: this.table.pageSize, pageNum: this.table.currentPage };
            for (const key in this.searchForm) {
                params[key] = this.searchForm[key];
            }
            params.orgIdList = [];
            this.searchForm.sOrgIds.forEach((item, index) => {
                params.orgIdList[index] = item.id;
            });
            Api.queryUserInfoByPage(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/customAudit/queryUserInfoByPage', response);
                    return;
                }
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    this.table.data = response.data.content.resultlist;
                    this.table.totals = response.data.content.total;
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.TABLE_REFRESH_FAIL') });
                }
            });
        },
        handleSizeChange(pageSize) {
            this.table.pageSize = pageSize;
            this.queryUserInfo();
        },
        currentPageChange(currentPage) {
            this.table.currentPage = currentPage;
            this.queryUserInfo();
        },
        //保存添加档案
        save() {
            this.$refs.asideForm.validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    let params = [];
                    let sAuditGroupId = this.data.currentTreeNode.id;
                    let auditRelateVoList = [];
                    this.expandResources.forEach(item => {
                        let obj = {};
                        obj.sLabelGroupId = item.sId;
                        obj.sLabelId = item.value;
                        try {
                            auditRelateVoList.push(JSON.parse(JSON.stringify(obj)));
                        } catch (e) {
                            console.log('Json conversion failed', e);
                        }
                    });
                    this.$refs.table.multipleSelection.forEach(item => {
                        let addElement = {
                            sAuditGroupId: sAuditGroupId,
                            sUserId: item.sId,
                            auditRelateVoList: auditRelateVoList
                        };
                        try {
                            params.push(JSON.parse(JSON.stringify(addElement)));
                        } catch (e) {
                            console.log('Json conversion failed', e);
                        }
                    });
                    params.auditRelateVoList = auditRelateVoList;
                    Api.addFileInfo(params, response => {
                        this.submitLoading = false;
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$log.error('/auditManage/addBatchAudit', response);
                            return;
                        }
                        if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                            this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.ADD_AUDIT_INFO_FAIL') });
                        } else {
                            this.$message({ type: 'success', showClose: true, message: this.$t('workFlowProcessAudit.ADD_AUDIT_INFO_SUCCESS') + response.data.content });
                            this.$emit('queryFileInfo');
                            this.dialogClose();
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //弹窗关闭事件
        dialogClose() {
            this.$emit('dialogClose');
        }
    }
};
</script>

<style scoped>
.addFileDialog > .aside {
    width: 310px;
    padding-top: 20px;
}
.addFileDialog > .aside > div {
    border-right: 2px solid rgb(5, 58, 96);
    height: 500px;
    overflow-y: auto;
}
.aside >>> .el-form {
    padding-top: 0;
}
.aside >>> .el-form-item:first-child {
    padding-top: 0;
}
.orgStructSelect >>> .el-popover__reference {
    width: 200px !important;
    height: 36px !important;
}
</style>
